// extracted by mini-css-extract-plugin
export default {"radioGroupLabel":"FormRadioGroup_radioGroupLabel__uU9Rq"};